// extracted by mini-css-extract-plugin
export default {"Wrapper":"App_Wrapper__z7syU","Board":"App_Board__g-PDH"};